import { create } from "zustand";
import { DEFAULT_BRANDING, type Branding } from "@/api/branding";

interface BrandingState {
  branding: Branding;
  resolved: boolean;
  setBranding: (b: Branding) => void;
  reset: () => void;
}

/** Holds the resolved per-group brand for the admin app. Defaults to
 *  the Mina Prime look so chrome never renders empty. */
export const useBrandingStore = create<BrandingState>((set) => ({
  branding: DEFAULT_BRANDING,
  resolved: false,
  setBranding: (b) => set({ branding: b, resolved: true }),
  reset: () => set({ branding: DEFAULT_BRANDING, resolved: false }),
}));
